import { useRef, useState } from "react";

export default function VideoPlayer() {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);

  const togglePlay = () => {
    const video = videoRef.current;
    if (!video) return;

    if (isPlaying) {
      video.pause();
    } else {
      video.play();
    }
    setIsPlaying(!isPlaying);
  };

  const toggleMute = () => {
    const video = videoRef.current;
    if (!video) return;

    video.muted = !isMuted;
    setIsMuted(!isMuted);
  };

  return (
    <div className="video-container">
      <video
        ref={videoRef}
        src="/video.mp4"
        playsInline
        preload="metadata"
        muted={isMuted}
        className="video"
      />

      <div className="controls">
        <button className={isPlaying ? 'playing play-control' : 'pause play-control'} onClick={togglePlay}>
          <img src="./img/play.svg" alt="Icon play video" />
          <img className="pause-img" src="./img/pause.svg" alt="Icon pause video" />
        </button>

        {isPlaying ? <div className="mute" onClick={toggleMute}>
          {isMuted ?
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="22" viewBox="0 0 25 22" >
            <path d="M4 5.21V16.21H0V5.21H4ZM6 16.92L14 21.42V0L6 4.5V16.92Z" />
            <line x1="16.636" y1="14.2929" x2="23.636" y2="7.29289" stroke="#482BFF" stroke-width="2"/>
            <line x1="16.7071" y1="7.29289" x2="23.7071" y2="14.2929" stroke="#482BFF" stroke-width="2"/>
          </svg>
            :
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" >
            <path d="M4 5.21V16.21H0V5.21H4ZM6 16.92L14 21.42V0L6 4.5V16.92ZM20.581 6.49L19.979 5.691L18.383 6.897L18.985 7.695C19.6409 8.56338 19.9957 9.62206 19.9953 10.7103C19.9949 11.7986 19.6395 12.8571 18.983 13.725L18.38 14.522L19.975 15.728L20.578 14.931C21.4972 13.7159 21.9948 12.2341 21.9953 10.7105C21.9959 9.18692 21.4993 7.70475 20.581 6.489" />
            <path d="M17.789 8.59903L17.186 7.80103L15.59 9.00603L16.193 9.80403C16.3899 10.0645 16.4964 10.382 16.4964 10.7085C16.4964 11.035 16.3899 11.3526 16.193 11.613L15.589 12.41L17.184 13.617L17.787 12.819C18.2464 12.2116 18.4952 11.4709 18.4955 10.7094C18.4959 9.94778 18.2478 9.20687 17.789 8.59903Z" />
            </svg>
          }
        </div> : ''}

      </div>
    </div >
  );
}
